import LookupCountriesRequestModelBase from '../_generated/modelBases/lookup-countries-request-model-base';

export default class LookupCountriesRequestModel extends LookupCountriesRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
